import { MasterButton, Modal, InputTextMaster } from "App/Component/ui"
import { Grid, Switch, Typography } from "@material-ui/core"
import React, { useState, useContext } from "react"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
} from "App/constants"
import {
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  convertToValidPrice,
} from "App/utils/helpers"
import { FormContext } from "../context/FormContext"
import { itSelfEmpty } from "utils/all"

const ModalPotongan = ({ setShowModal, setNewData }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)

  const { formData, setFormData } = useContext(FormContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      if (formData.diskon === "") {
        defaultToastError("Potongan tidak boleh kosong!")
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else {
        const api = await instance3.post("/rekap-tagihan/diskon", {
          id_rekap: formData.rekap_tagihan_id,
          diskon: parseFloat(formData.diskon),
          total_diskon: convertToValidPrice(formData.total_diskon),
        })
        const res = await api?.data
        if (res.status === 200) {
          await setNewData()
          setShowModal(false)
          defaultToastSuccess("Berhasil menyimpan potongan")
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        } else {
          defaultToastError(res?.message)
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  return (
    <Modal title={"Potongan Dalam Rekap Tagihan"} show={setShowModal}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item sm={12}>
            <InputTextMaster
              name="total_tagihan"
              label="TOTAL TAGIHAN"
              id="total_tagihan"
              placeholder="0"
              disabled={true}
              value={formatRupiah(formData.total_bayar_tagihan)}
              withButtonLeft={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "0",
                  background: "#f7f7f7",
                  padding: "0 0 0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                Rp.
              </button>
            </InputTextMaster>
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="diskon"
              label="DISKON (Rp)"
              id="diskon"
              placeholder="0"
              disabled={formData.total_bayar_tagihan == 0}
              value={formatRupiah(formData.total_diskon)}
              onInput={(e) => {
                let val = itSelfEmpty(
                  e.target.value,
                  0,
                  convertToValidPrice(e.target.value),
                )
                const totalBiaya = formData.total_bayar_tagihan
                const presentase_diskon = (val / totalBiaya) * 100
                setFormData({
                  ...formData,
                  diskon: isNaN(presentase_diskon) ? 0 : presentase_diskon,
                  total_diskon: val,
                })
              }}
              withButtonLeft={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "0",
                  background: "#fff",
                  padding: "0 0 0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                Rp.
              </button>
            </InputTextMaster>
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="diskon_presen"
              label="DISKON (%)"
              id="diskon_persen"
              placeholder="0"
              disabled={formData.total_bayar_tagihan == 0}
              value={formData.diskon}
              onInput={(e) => {
                let val = e.target.value
                setFormData({
                  ...formData,
                  diskon: val,
                  total_diskon: isNaN(formData.total_bayar_tagihan)
                    ? 0
                    : (formData.total_bayar_tagihan * val) / 100,
                })
              }}
              withButton={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderRight: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderLeft: "0",
                  background: "#fff",
                  padding: "0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "0 6px 6px 0",
                }}
              >
                %
              </button>
            </InputTextMaster>
          </Grid>
          {/* <Grid item sm={12}>
            <InputTextMaster
              name="total_disc"
              label="SUB DISKON"
              id="total_disc"
              placeholder="0"
              disabled={true}
              value={formatRupiah(formData.total_diskon)}
              withButtonLeft={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "0",
                  background: "#f7f7f7",
                  padding: "0 0 0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                Rp.
              </button>
            </InputTextMaster>
          </Grid> */}
          <Grid item sm={12}>
            <InputTextMaster
              name="sub_total"
              label="SUB TOTAL"
              id="sub_total"
              placeholder="0"
              disabled={true}
              value={formatRupiah(
                formData.total_bayar_tagihan - formData.total_diskon,
              )}
              withButtonLeft={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "0",
                  background: "#f7f7f7",
                  padding: "0 0 0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                Rp.
              </button>
            </InputTextMaster>
          </Grid>
        </Grid>

        <div>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MasterButton
              className={"mt-1"}
              type="submit"
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.disabled}
              size="md"
            />
          </Grid>
        </div>
      </form>
    </Modal>
  )
}

export default ModalPotongan
